import { render, staticRenderFns } from "./StartUserDialog.vue?vue&type=template&id=70135e02&scoped=true&"
import script from "./StartUserDialog.vue?vue&type=script&lang=js&"
export * from "./StartUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./StartUserDialog.vue?vue&type=style&index=0&id=70135e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70135e02",
  null
  
)

export default component.exports